import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export const PASSWORD_MIN_LENGTH = 8;
export const PasswordStrengthValidator = function (control: AbstractControl): ValidationErrors {
  const value: string = control.value || '';
  const upperCaseCharactersRegex = /[A-Z]+/g;
  const lowerCaseCharactersRegex = /[a-z]+/g;
  const numberCharactersRegex = /[0-9]+/g;
  const specialCharactersRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;

  if (!value) {
    return {};
  }

  const hasUpperCaseCharacters = upperCaseCharactersRegex.test(value);
  const hasLowerCaseCharacters = lowerCaseCharactersRegex.test(value);
  const hasNumberCharacters = numberCharactersRegex.test(value);
  const hasSpecialCharacters = specialCharactersRegex.test(value);

  const validArray = [hasUpperCaseCharacters, hasLowerCaseCharacters, hasNumberCharacters, hasSpecialCharacters].filter(el => el);

  if (validArray.length < 2) {
    return {
      passwordStrength: true,
    };
  } else {
    return {};
  }
};

export function ConfirmedValidator(controlName: string, matchingControlName: string): any {
  return (formGroup: FormGroup) => {
    if (!formGroup.contains(controlName) || !formGroup.contains(matchingControlName)) {
      return;
    }
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors['confirmedValidator']) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmedValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
